"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanValidator = void 0;
const Validator_1 = require("./Validator");
const ERRORS = {
    IS_BOOLEAN: 'IS_BOOLEAN',
    IS_FALSY: 'IS_FALSY',
    IS_TRUTHY: 'IS_TRUTHY',
};
class BooleanValidator extends Validator_1.Validator {
    static isBoolean(value) {
        return typeof value === 'boolean';
    }
    static isTruthy(value) {
        return value === true;
    }
    static isFalsy(value) {
        return value === false;
    }
}
exports.BooleanValidator = BooleanValidator;
_a = BooleanValidator;
BooleanValidator.IS_BOOLEAN = () => _a.validatorFactory(_a.isBoolean, ERRORS.IS_BOOLEAN);
BooleanValidator.IS_TRUTHY = () => _a.validatorFactory(_a.isTruthy, ERRORS.IS_TRUTHY);
BooleanValidator.IS_FALSY = () => _a.validatorFactory(_a.isFalsy, ERRORS.IS_FALSY);
//# sourceMappingURL=BooleanValidator.js.map